import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-clock-icon',
  templateUrl: 'clock-icon.component.html'
})
export class ClockIconComponent {
  constructor() {}
}
